export default {"src":"/_next/static/media/square-small.59d64f92.svg","height":173,"width":200,"blurWidth":0,"blurHeight":0};